/* Datepicker */
DatePicker();

function DatePicker() {
    $.datepicker.regional['cs-CZ'] = {
        closeText          : 'Zavřít',
        prevText           : 'Předchozí',
        nextText           : 'Další',
        currentText        : 'Hoy',
        monthNames         : ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'],
        monthNamesShort    : ['Le', 'Ún', 'Bř', 'Du', 'Kv', 'Čn', 'Čc', 'Sr', 'Zá', 'Ří', 'Li', 'Pr'],
        dayNames           : ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'],
        dayNamesShort      : ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
        dayNamesMin        : ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
        weekHeader         : 'Sm',
        firstDay           : 1,
        isRTL              : false,
        showMonthAfterYear : false,
        yearSuffix         : ''
    };

    $.datepicker.regional['sk-SK'] = {
        closeText          : 'Zavrieť',
        prevText           : 'Predchádzajúci',
        nextText           : 'Ďalší',
        currentText        : 'Hoy',
        monthNames         : ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December'],
        monthNamesShort    : ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
        dayNames           : ['Nedeľa', 'Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
        dayNamesShort      : ['Ne', 'Po', 'Ut', 'St', 'Št', 'Pi', 'So'],
        dayNamesMin        : ['Ne', 'Po', 'Ut', 'St', 'Štv', 'Pa', 'So'],
        weekHeader         : 'Sm',
        firstDay           : 1,
        isRTL              : false,
        showMonthAfterYear : false,
        yearSuffix         : ''
    };

    $.datepicker.regional['de-DE'] = {
        closeText          : 'Schließen',
        prevText           : 'Zurück',
        nextText           : 'Vor',
        currentText        : 'Heute',
        monthNames         : ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
        monthNamesShort    : ['Jan','Feb','Mär','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Dez'],
        dayNames           : ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
        dayNamesShort      : ['So','Mo','Di','Mi','Do','Fr','Sa'],
        dayNamesMin        : ['So','Mo','Di','Mi','Do','Fr','Sa'],
        weekHeader         : 'Sm',
        firstDay           : 1,
        isRTL              : false,
        showMonthAfterYear : false,
        yearSuffix         : ''
    };

    $.datepicker.regional['pl-PL'] = {
        closeText           : "Zamknij",
        prevText            : "&#x3C;Poprzedni",
        nextText            : "Następny&#x3E;",
        currentText         : "Dziś",
        monthNames          : [ "Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień" ],
        monthNamesShort     : [ "Sty","Lu","Mar","Kw","Maj","Cze","Lip","Sie","Wrz","Pa","Lis","Gru" ],
        dayNames            : [ "Niedziela","Poniedziałek","Wtorek","Środa","Czwartek","Piątek","Sobota" ],
        dayNamesShort       : [ "Nie","Pn","Wt","Śr","Czw","Pt","So" ],
        dayNamesMin         : [ "N","Pn","Wt","Śr","Cz","Pt","So" ],
        weekHeader          : "Tydz",
        firstDay            : 1,
        isRTL               : false,
        showMonthAfterYear  : false,
        yearSuffix          : ""
    };

    $.datepicker.regional['hu-HU'] = {
        closeText: "Bezár",
        prevText: "Vissza",
        nextText: "Előre",
        currentText: "Ma",
        monthNames: [ "Január", "Február", "Március", "Április", "Május", "Június", "Július", "Augusztus", "Szeptember", "Október", "November", "December" ],
        monthNamesShort: [ "Jan", "Feb", "Már", "Ápr", "Máj", "Jún", "Júl", "Aug", "Szep", "Okt", "Nov", "Dec" ],
        dayNames: [ "Vasárnap", "Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat" ],
        dayNamesShort: [ "Vas", "Hét", "Ked", "Sze", "Csü", "Pén", "Szo" ],
        dayNamesMin: [ "V", "H", "K", "Sze", "Cs", "P", "Szo" ],
        weekHeader: "Hét",
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: "" };

    $(".awe-calendar:not(.from, .to)").each(function () {
        $(this).datepicker({
            prevText        : '<i class="hillter-icon-left-arrow"></i>',
            nextText        : '<i class="fas fa-arrow-right"></i>',
            buttonImageOnly : false
        });
    });



    /* Datepicker from - to */

    $(".awe-calendar.from").each(function () {
        var toPicker = $(this).closest("form").find(".awe-calendar.to");

        $(this).datepicker({
            prevText        : '<i class="fas fa-arrow-left"></i>',
            nextText        : '<i class="fas fa-arrow-right"></i>',
            buttonImageOnly : false,
            dateFormat      : 'yy-mm-dd',
            minDate         : 0,
            onClose         : function (selectedDate) {
                var newDate = new Date(toDate(selectedDate)),
                    tomorrow = new Date(newDate.getTime() + 24 * 60 * 60 * 1000),
                    nextDate = tomorrow.getFullYear() + '-' + (tomorrow.getMonth() + 1) + '-' + tomorrow.getDate();
                $(toPicker).datepicker("option", "minDate", nextDate);
            }
        });
    })

    $(".awe-calendar.to").each(function () {
        var fromPicker = $(this).closest("form").find(".awe-calendar.from");

        $(this).datepicker({
            prevText        : '<i class="fas fa-arrow-left"></i>',
            nextText        : '<i class="fas fa-arrow-right"></i>',
            buttonImageOnly : false,
            dateFormat      : 'yy-mm-dd',
            minDate         : 0,
            onClose         : function (selectedDate) {
                fromPicker.datepicker( "option", "maxDate", selectedDate );
            }
        });
    });
}

function toDate(dateStr) {
    var parts = dateStr.split("-");
    return new Date(parts[0], parts[1] - 1, parts[2]);
}


/* aweCalendar */
aweCalendar();

function aweCalendar() {
    $('.awe-calendar').each(function () {
        var aweselect = $(this);
        //aweselect.wrap('<div class="awe-calendar-wrapper"></div>');
        aweselect.after('<i class="far fa-calendar-alt"></i>');
        $(".fa-calendar-alt").on("click", function(){
            $(this).siblings("input").datepicker("show");
        });
    });
}

// END OF DATEPICKER
